import React, { useState } from 'react';
import { personalInfo } from '../data/data';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Message sent! 🚀");
    setFormData({ name: '', email: '', message: '' });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contact" className="py-32 px-6 text-center">
      
      {/* TITLE */}
      <h2 className="text-4xl md:text-5xl font-bold mb-6">
        Get In <span className="text-cyan-400 glow">Touch</span>
      </h2>

      <p className="text-gray-400 mb-12">
        Let’s build something futuristic together
      </p>

      {/* CARD */}
      <div className="max-w-xl mx-auto bg-[#111]/60 backdrop-blur-lg border border-cyan-400/20 rounded-2xl p-8 transition-all duration-300 hover:border-cyan-400 hover:shadow-[0_0_40px_rgba(0,255,255,0.2)]">

        {/* SOCIAL */}
        <div className="mb-6 space-y-2 text-gray-300">
          <p>
            <span className="text-cyan-400">LinkedIn:</span>{" "}
            <a
              href={personalInfo.linkedin}
              target="_blank"
              rel="noreferrer"
              className="hover:text-cyan-400 transition"
            >
              Connect
            </a>
          </p>

          <p>
            <span className="text-cyan-400">Email:</span>{" "}
            {personalInfo.email}
          </p>
        </div>

        {/* FORM */}
        <form onSubmit={handleSubmit} className="space-y-4">

          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
            className="w-full p-3 rounded-lg bg-black/40 border border-gray-700 focus:border-cyan-400 outline-none transition"
          />

          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            required
            className="w-full p-3 rounded-lg bg-black/40 border border-gray-700 focus:border-cyan-400 outline-none transition"
          />

          <textarea
            name="message"
            placeholder="Your Message"
            value={formData.message}
            onChange={handleChange}
            required
            rows={4}
            className="w-full p-3 rounded-lg bg-black/40 border border-gray-700 focus:border-cyan-400 outline-none transition"
          />

          <button
            type="submit"
            className="w-full py-3 border border-cyan-400 text-cyan-400 rounded-lg hover:bg-cyan-400 hover:text-black transition-all duration-300 glow"
          >
            Send Message
          </button>

        </form>

      </div>

    </section>
  );
};

export default ContactSection;